import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Eye, EyeOff, ArrowRight } from "lucide-react";
import { Logo } from "@/components/lf";
import { login } from "@/lib/auth";

export default function Login() {
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("logika@filsuf.com");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const r = await login(email, password);
    setBusy(false);
    if (!r.ok) return setError(r.message);
    navigate(loc.state?.from || "/ringkasan", { replace: true });
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#0B0B0D]" data-testid="login-page">
      <section className="relative min-h-[46vh] lg:min-h-screen overflow-hidden border-b lg:border-b-0 lg:border-r border-[#29292D]" data-testid="login-hero">
        <img src="/images/login-philosophers.jpg" alt="Para filsuf berdiskusi di bawah cahaya lilin" className="absolute inset-0 w-full h-full object-cover object-[center_30%]" data-testid="login-artwork" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0D] via-[#0B0B0D]/55 to-[#0B0B0D]/25" />
        <div className="relative h-full min-h-[46vh] lg:min-h-screen flex flex-col justify-between p-6 sm:p-10 lg:p-14">
          <div className="flex items-center gap-3">
            <Logo size={60} />
            <div>
              <div className="font-serif text-2xl text-[#F2F0EC] leading-none">Logika Filsuf</div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-[#E6E2D6]/80 mt-1">Philosophy is Easy</div>
            </div>
          </div>
          <div className="max-w-lg">
            <div className="lf-overline !text-[#E6E2D6]/80 mb-3">Teras membaca & berpikir kritis</div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight text-[#F2F0EC]" data-testid="login-headline">
              Pertanyaan yang baik mengubah cara kita membaca.
            </h1>
          </div>
        </div>
      </section>

      <section className="flex items-center justify-center px-6 sm:px-12 py-14 bg-[#0B0B0D]">
        <form onSubmit={submit} className="w-full max-w-md lf-fade" data-testid="login-form">
          <div className="lf-overline mb-4">Masuk</div>
          <h2 className="text-4xl sm:text-5xl font-medium leading-none text-[#F2F0EC]">Selamat datang kembali.</h2>
          <p className="text-sm text-[#929197] mt-4 leading-relaxed">Lanjutkan perjalanan membaca Anda dengan akun demo yang sudah disiapkan.</p>

          <div className="mt-10 space-y-5">
            <label className="block">
              <span className="block text-xs font-semibold text-[#929197] mb-1.5">Email</span>
              <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="lf-field" autoComplete="username" required />
            </label>
            <label className="block">
              <span className="block text-xs font-semibold text-[#929197] mb-1.5">Kata sandi</span>
              <div className="relative">
                <input data-testid="login-password-input" type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className="lf-field !pr-11" autoComplete="current-password" placeholder="Masukkan kata sandi" required />
                <button type="button" onClick={() => setShow((s) => !s)} data-testid="login-password-toggle" aria-label={show ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#929197] hover:text-[#F2F0EC]">
                  {show ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
            </label>
            {error && <div data-testid="login-error" role="alert" className="border border-[#7a3434] bg-[#1e1214] text-[#e3a6a6] text-sm px-4 py-3 rounded-sm">{error}</div>}
            <button type="submit" disabled={busy} data-testid="login-submit-button" className="lf-btn w-full !py-3.5">
              {busy ? "Memeriksa…" : "Masuk ke teras membaca"} {!busy && <ArrowRight size={16} />}
            </button>
          </div>
          <p className="text-xs text-[#6b6a70] mt-8 leading-relaxed">Prototipe demo: autentikasi berjalan di peramban Anda dan hanya untuk satu akun tetap.</p>
        </form>
      </section>
    </div>
  );
}
